'use client'
import { ErrorMsg } from '@/components/error-msg'
import { useErrorToast } from '@/components/toastHook'
import InputField from '@a24/form/InputField'
import Button from '@a24/ui/Button'
import { useActionState, useRef, useTransition } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import CustomerDetailsForm from '../customer/customer-details-form'
import { type ISignupFormData, type State, handleSignUp } from './action'
interface IProps {
  defaultValues?: Partial<ISignupFormData>
  redirect?: boolean
}

const initialState = null
const SignUpForm = ({ defaultValues, redirect = true }: IProps) => {
  const formMethods = useForm<ISignupFormData>({ defaultValues })
  const formRef = useRef<HTMLFormElement>(null)
  const [state, formAction, isPending] = useActionState<State, FormData>(
    handleSignUp,
    initialState
  )
  const [isSignUpPending, startTransition] = useTransition()
  useErrorToast(state)

  return (
    <div className='md:pb-20'>
      <FormProvider {...formMethods}>
        <form
          ref={formRef}
          id='signup-form'
          className='md:py-14'
          onSubmit={formMethods.handleSubmit((data) => {
            // biome-ignore lint/style/noNonNullAssertion: <explanation>
            startTransition(() => formAction(new FormData(formRef.current!)))
          })}
        >
          {!defaultValues?.customer_Id && (
            <CustomerDetailsForm isAuthenticated={false} />
          )}
          <InputField
            outerWrapperClassName='hidden'
            name='customer_Id'
            value={defaultValues?.customer_Id}
          />
          <div className='grid md:flex gap-6 mt-10'>
            <InputField
              outerWrapperClassName='w-full label-md'
              placeholder='******'
              name='password'
              label='Password'
              type='password'
              rules={{
                maxLength: 30,
                required: 'Password is required',
                validate: (value) => {
                  if (value.length < 8 || !/[a-z]/.test(value)) {
                    return 'Password must be at least 8 characters and contain at least 1 lowercase letter'
                  }
                }
              }}
            />
            <InputField
              outerWrapperClassName='w-full label-md'
              placeholder='******'
              name='comp_password'
              label='Confirm password'
              type='password'
              rules={{
                maxLength: 30,
                required: 'Password is required',
                validate: (value, { password }) => {
                  if (value !== password) {
                    return 'Passwords must be the same'
                  }
                }
              }}
            />
          </div>
          {state && <ErrorMsg state={state} />}
        </form>
        <div className='flex justify-center'>
          <Button
            disabled={isSignUpPending || isPending}
            aria-disabled={isSignUpPending || isPending}
            type='submit'
            form='signup-form'
            className='button-secondary mt-5'
          >
            Create an account
          </Button>
          <InputField
            outerWrapperClassName='hidden'
            name='redirect'
            value={redirect ? 'true' : 'false'}
          />
        </div>
      </FormProvider>
    </div>
  )
}

export default SignUpForm
